package modysy.simulation.pp

import modysy.model.{Agent, GameObject}
import modysy.simulation.pp.SuccessConditions.LevelResult.LevelResult

/**
  * Contains functions Seq[GameObject] => GameResult
  * which can be used to evaluate the success condtion
  *
  */
object SuccessConditions {

  /**
    * Possible results of a level: undecided, win, lose
    */
  object LevelResult extends Enumeration {
    type LevelResult = Value
    val undecided, win, lose = Value
  }

  private def filterAgents(objects: Seq[GameObject]): Seq[Agent] =
    objects
      .filter((obj) => {
        obj match {
          case a: Agent => true
          case _        => false
        }
      })
      .asInstanceOf[Seq[Agent]]

  /**
    * Success condition for level-Scenario "Convert them all"
    *
    * @param desiredOutput All agents are supposed to convert to a state with state.output == desiredOutput
    * @return LevelResult.win if all agents converged, LevelResult.undecided otherwise
    */
  def convertThemAll(desiredOutput: Output): Seq[GameObject] => LevelResult =
    (objects: Seq[GameObject]) => {

      val agents = filterAgents(objects)
      var result = LevelResult.undecided
      if (agents.forall(agent => agent.state.output == desiredOutput))
        result = LevelResult.win

      result
    }

  def tryToSurvive(desiredOutput: Output): Seq[GameObject] => LevelResult =
    (objects: Seq[GameObject]) => {
      val agents = filterAgents(objects)
      var result = LevelResult.undecided
      if (!agents.exists(agent => agent.state.output == desiredOutput))
        result = LevelResult.lose

      result
    }

  /**
    * Success condition for level-Scenario "Leader-Election"
    *
    * @param playerAgent  agent the player wants to be elected leader
    * @param leaderOutput output which indicates a leader-state
    * @return LevelResult.undecided if no or multiple agents in a leader-state exist
    *         LevelResult.win if playerAgent is the only agent in a leader-state
    *         LevelResult.lose if any other agent is the only agent in a leader-state
    */
  def leaderElection(
      playerAgent: Agent,
      leaderOutput: Output
  ): Seq[GameObject] => LevelResult = { objects: Seq[GameObject] =>
    {

      val agents = filterAgents(objects)
      var result = LevelResult.undecided

      def getLeader(ags: Seq[Agent], lead: Option[Agent]): Option[Agent] = {

        ags match {
          case Nil => lead
          case ag :: rest => {
            if (ag.state.output == leaderOutput) {
              lead match {
                case None => getLeader(rest, Some(ag))
                case _    => None
              }

            } else {
              getLeader(rest, lead)
            }
          }
        }

      }

      val leader = getLeader(agents, None)

      if (leader.contains(playerAgent))
        result = LevelResult.win
      else if (!leader.isEmpty)
        result = LevelResult.lose

      result
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/pp/SuccessConditions.scala